/**
 * Async review list prices: the one frontend copy of the backend's
 * `TURNAROUND_RATES` in `backend/routes/verifications.py`.
 *
 * Prices are fixed per turnaround and the same for every reviewer. There is
 * no per-expert async price, no free tier and no discount (founder decision,
 * 2026-10-07). Marketing pages read these values instead of hard-coding
 * numbers, so a price change is one edit here plus the backend.
 * `reviewPricing.test.js` fails if this list and the backend drift apart.
 */
export const REVIEW_TIERS = [
  { key: "24h",    label: "24 hours", price: 99 },
  { key: "48h",    label: "48 hours", price: 69 },
  { key: "1_week", label: "1 week",   price: 49 },
];

/** Lowest list price, for "from $X" lines. */
export const REVIEW_PRICE_FROM = Math.min(...REVIEW_TIERS.map((t) => t.price));
